const Data = [
  {
    id: 1,
    image:
      "https://images.pexels.com/photos/3998177/pexels-photo-3998177.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born",
    category: "category1",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 2,
    image:
      "https://images.pexels.com/photos/2218558/pexels-photo-2218558.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      " I will give you a complete account of the system, and expound the actual teachings of the great explorer you a complete account of the system, and expound the actual teachings of the great explorer",
    category: "category2",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 3,
    image:
      "https://images.pexels.com/photos/2421190/pexels-photo-2421190.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "demoralized by the charms of pleasure of the moment, so blinded by desire, that they cannot foresee",
    category: "category3",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 4,
    image:
      "https://images.pexels.com/photos/3787395/pexels-photo-3787395.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category4",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 5,
    image:
      "https://images.pexels.com/photos/904124/pexels-photo-904124.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category1",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 6,
    image:
      "https://images.pexels.com/photos/10786928/pexels-photo-10786928.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category1",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 7,
    image:
      "https://images.pexels.com/photos/1934780/pexels-photo-1934780.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category1",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 8,
    image:
      "https://images.pexels.com/photos/6387657/pexels-photo-6387657.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category2",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 9,
    image:
      "https://images.pexels.com/photos/3998098/pexels-photo-3998098.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category2",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 10,
    image:
      "https://images.pexels.com/photos/11279839/pexels-photo-11279839.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category2",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 11,
    image:
      "https://images.pexels.com/photos/1484990/pexels-photo-1484990.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category3",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 12,
    image:
      "https://images.pexels.com/photos/4552397/pexels-photo-4552397.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category3",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 13,
    image:
      "https://images.pexels.com/photos/1934780/pexels-photo-1934780.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category1",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 14,
    image:
      "https://images.pexels.com/photos/6387657/pexels-photo-6387657.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category2",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 15,
    image:
      "https://images.pexels.com/photos/3998098/pexels-photo-3998098.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category2",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 16,
    image:
      "https://images.pexels.com/photos/11279839/pexels-photo-11279839.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category2",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 17,
    image:
      "https://images.pexels.com/photos/1484990/pexels-photo-1484990.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category3",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
  {
    id: 18,
    image:
      "https://images.pexels.com/photos/4552397/pexels-photo-4552397.jpeg?auto=compress&cs=tinysrgb&w=1600",
    title:
      "But who has any right to find fault with a man who chooses to enjoy a pleasure that has no annoying consequences,",
    category: "category3",
    desc: " Lorem ipsum dolor sit amet consectetur, adipisicing elit. Commodi ad perspiciatis, modi corporis voluptate aliquid maxime sunt quisquam maiores perferendis illo quo facilis cum sint magnam amet possimus harum eaque.",
  },
];

export default Data;
